<template>
  <div
    style="text-align: right;"
  >
    <el-tooltip
      class="item"
      effect="dark"
      content="Módosítás"
      placement="top"
      v-can="'tourcalendar.update'"
    >
      <el-button
        size="mini"
        icon="el-icon-edit"
        style="margin-left: 5px;"
        @click="updateTourCalendar"
      />
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      :content="'Törlés'"
      placement="top"
      style="margin-left: 5px;"
      v-can="'tourcalendar.delete'"
    >
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteTourCalendar"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          size="mini"
          icon="el-icon-delete"
        />
      </el-popover>
    </el-tooltip>
  </div>
</template>

<script>
  export default {
    props: ['tourCalendar'],
    data() {
      return {
        deleteButtonLoader: false,
        deleteConfirmVisible: false,
      };
    },

    methods: {
      async deleteTourCalendar() {
        this.deleteButtonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('tourCalendar/delete', this.tourCalendar.id);
          this.$store.dispatch('tourCalendar/fetchAll');
        } catch (e) {
        }
        this.deleteButtonLoader = false;
      },
      async updateTourCalendar() {
        this.$router.push('/representative-processes/tour-calendars/update/' + this.tourCalendar.id);
      },
    }
  };
</script>
